export const ARTICLE_TEMPLATES = {
  STANDARD: 'standard',
  GALLERY: 'gallery',
};

export const DEFAULT_TEMPLATE = ARTICLE_TEMPLATES.STANDARD;
